import FeatherIcon from "feather-icons-react";
import React, { FC, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { parse } from "papaparse";
import { EmissionFactorCsvDataDto } from "@green0meter/api-client";

import { Button } from "@components/base";
import { useImportEmissionFactorCsv } from "@api";
import { useUserStore } from "@store/user";

const ImportEmissionFactorsButton: FC = () => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { importEmissionFactorCsv } = useImportEmissionFactorCsv(user);

  const handleImportEmissionFactor = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    const file = event.target.files?.[0];

    setIsLoading(true);

    if (!file) {
      setIsLoading(false);

      return;
    }

    parse(file, {
      header: true,
      complete: async (results) => {
        const parsedData = results.data as Record<string, string>[];
        const csvData: EmissionFactorCsvDataDto[] = [];

        parsedData.forEach((row) => {
          const formData: EmissionFactorCsvDataDto = {
            factor: row["factor"] || "0",
            scope: row["scope"] || "",
            unitAbbreviation: row["unitAbbreviation"] || "",
            questionCodes: row["questionCodes"] || "",
            year: row["year"] || "",
            type: row["type"] || "",
            source: row["source"] || "",
            sourceDetail: row["sourceDetail"] || "",
          };

          csvData.push(formData);
        });

        await importEmissionFactorCsv(csvData);

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

        setIsLoading(false);
      },
      error: () => {
        setIsLoading(false);
      },
    });
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={() => fileInputRef.current?.click()}
        startIcon={<FeatherIcon icon="download" width="16" height="16" />}
        loading={isLoading}
      >
        {t("admin.emissionFactorsManagement.importButton")}
      </Button>
      <input
        type="file"
        style={{ display: "none" }}
        accept=".csv"
        ref={fileInputRef}
        onChange={handleImportEmissionFactor}
      />
    </>
  );
};

export default ImportEmissionFactorsButton;
